<template>
  <div>
    <div class="top_right_wrapper">
      <!-- 多云 PM2.5
    <img src="@/assets/images/dot-green.png" width="8" height="8" />
    良好&nbsp;&nbsp;&nbsp;&nbsp;{{ currentTime.date }} {{ currentTime.day }}
    {{ currentTime.time }} -->
      <div class="weather">
        <div class="weather_img">
          <!-- <img src="@/assets/img/img_weather2.png" /> -->
        </div>
        <div class="weather_txt col_white">
          <!-- <span>阴天</span><br />
          <span>19°C</span> -->
        <weather />
        </div>
      </div>
      <div class="top_right_line bgc_354"></div>
      <div class="time col_84c">{{ currentTime.time }}</div>
      <div class="date col_white">
        <span>{{ currentTime.day }}</span
        ><br />{{ currentTime.date }}
      </div>
    </div>
  </div>
</template>

<script>
import weather from "@/components/WeatherTool.vue";
export default {
  data() {
    return {
      // 当前时间
      currentTime: {
        timer: null,
        date: null,
        time: null,
        day: null,
      },
    };
  },
    components: { weather},
  created() {
    let that = this;
    //时间定时刷新
    this.currentTime.timer = setInterval(function () {
      that.handleCurrentTimeRefresh();
    }, 1000);
  },
  beforeDestroy() {
    if (this.currentTime.timer) clearTimeout(this.currentTime.timer);
  },
  methods: {
    // 定时刷新当前时间
    handleCurrentTimeRefresh() {
      let date = new Date();
      var weeks = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      this.currentTime.date =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10 ? "0" + (date.getMonth()+1) : (date.getMonth())+1) +
        "-" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
      let hour = date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      this.currentTime.time = hour + ":" + minutes + ":" + seconds;
      this.currentTime.day = weeks[date.getDay()];
    },
  },
};
</script>
<style scoped src="@/assets/css/index2.css"></style>
<style scoped src="@/assets/css/pop.css"></style>